<template>
  <div class="modal-content">
    <div class="modal-header">
      <h4 class="modal-title"><i class="fa fa-fw fa-key"></i> {{ _('API key created') }}</h4>
    </div>
    <div class="modal-body">
      <p class="alert alert-warning">
        <i class="fa fa-fw fa-triangle-exclamation"></i>
        {{ _('Copy the key now and give it to the partner securely. It is shown only once: Johku stores only a hash of it, so it can\'t be shown again.') }}
      </p>
      <div class="form-group">
        <label for="partnerKeySecret">{{ keyLabel || _('API key') }}</label>
        <div class="input-group">
          <input class="form-control partner-key-secret" id="partnerKeySecret" type="text" readonly :value="secret" v-on:focus="$event.target.select()" />
          <span class="input-group-btn">
            <button class="btn btn-success" type="button" v-on:click="copy"><i class="fa fa-fw fa-copy"></i> {{ _('Copy') }}</button>
          </span>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button class="btn btn-default" type="button" v-on:click="close"><i class="fa fa-fw fa-check"></i> {{ copied ? _('Close') : _('I have stored the key') }}</button>
    </div>
  </div>
</template>

<script>
import errors from '~/lib/errors'

// Shows a new partner API key's secret once (AdminPartnerIntegrationDetails). The secret is only in the
// create_key response and is never stored in the POS.
export default {
  mixins: [errors],
  props: ['secret', 'keyLabel'],
  data () {
    return {
      copied: false
    }
  },
  methods: {
    async copy () {
      try {
        await this.$copyText(this.secret)
        this.copied = true
        this.showNotification(this._('API key copied to clipboard!'))
      } catch (e) {
        this.showError(e)
      }
    },
    close () {
      this.$emit('close')
    }
  }
}
</script>

<style scoped>
.partner-key-secret {
  font-family: monospace;
}
</style>
